import { defineStore } from 'pinia'

import { createProductsActions } from './actions'
import { createProductsState } from './state'

export const useProductsStore = defineStore('products', () => {
    const state = createProductsState()
    const actions = createProductsActions(state)

    return {
        ...state,
        ...actions
    }
})
